"use client";

import dynamic from "next/dynamic";

import ChatLoading from "@/components/ai/chat/chat-loading";
import { AGENT_NAMES } from "@/lib/constants/agents";

// const AdminAgent = dynamic(() => import("@/components/ai/agents/admin"), {
//   ssr: false,
// });

// const WeatherAgent = dynamic(() => import("@/components/ai/agents/weather"), {
//   ssr: false,
// });

// const DashboardAgent = dynamic(
//   () => import("@/components/ai/agents/dashboard"),
//   {
//     ssr: false,
//   },
// );

// const WorkBreakdownAgent = dynamic(
//   () => import("@/components/ai/agents/work"),
//   {
//     ssr: false,
//   },
// );

const KriyaAgent = dynamic(() => import("@/components/ai/agents/kriya-agent"), {
  ssr: false,
  loading: () => (
    <div className="flex h-full items-center justify-center">
      <ChatLoading />
    </div>
  ),
});

type ChatProps = {
  agentName: (typeof AGENT_NAMES)[keyof typeof AGENT_NAMES];
};

const Chat = ({ agentName }: Readonly<ChatProps>) => {
  switch (agentName) {
    // case AGENT_NAMES.WEATHER:
    //   return <WeatherAgent />;
    // case AGENT_NAMES.ADMIN:
    //   return <AdminAgent />;
    // case AGENT_NAMES.WORK_BREAKDOWN:
    //   return <WorkBreakdownAgent />;
    // case AGENT_NAMES.DASHBOARD:
    //   return <DashboardAgent />;
    case AGENT_NAMES.KRIYA:
      return <KriyaAgent />;
    // case AGENT_NAMES.SCHEDULE_OPTIMIZER:
    //   return <ScheduleOptimizerAgent />;
    // case AGENT_NAMES.WBS_OPTIMIZER:
    //   return <WbsOptimizerAgent />;
    default:
      return null;
  }
};

export default Chat;
